import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
var AppAudioPlayComponent = (function () {
    function AppAudioPlayComponent(commonService, apiService, route, router, el) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.el = el;
        //当前播放索引
        this.currentIndex = 0;
        //播放进度
        this.audioProcess = 0;
        //显示播放时长
        this.audioProcessTimes = "0:00/0:00";
        //播放状态
        this.playStatus = false;
        //第一次播放
        this.firstPlay = true;
        //是否显示 tool bar
        this.showToolBar = false;
        //当前显示模式
        this.showTextModel = "day";
        //弹窗提示
        this.showTipEnable = false;
        //显示加载提示
        this.showLoading = false;
        //最近一次 scrolll top 值
        this.lastScrollTop = 0;
        //是否touch
        this.touchEnable = false;
        this.touchEnableContent = false;
        this.touchX = 0;
        this.touchY = 0;
        this.moveTouchTimes = 0;
        this.currentProcessWidth = 0;
        this.currentProcessBarWidth = 0;
    }
    AppAudioPlayComponent.prototype.onPopState = function () {
        if (this.audioObj) {
            this.audioObj.pause();
        }
    };
    AppAudioPlayComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.surveyMetaId = params['surveyMetaId'];
            _this.learningPathOrLearningTourId = params['learningPathOrLearningTourId'];
            _this.method = params['method'];
            _this.surveyId = params['surveyId'];
            _this.currentIndex = params['audioIndex'];
        });
        this.getAudioListInfo().subscribe(function (result) {
            _this.audioList = result;
            if (_this.audioList.length > 0) {
                _this.currentAudio = _this.audioList[_this.currentIndex];
                setTimeout(function () {
                    _this.audioInit();
                    _this.audioObj.src = _this.currentAudio.audioUrl;
                }, 300);
            }
        });
        this.getReport();
    };
    AppAudioPlayComponent.prototype.audioInit = function () {
        this.audioObj = this.el.nativeElement.querySelector("audio");
    };
    AppAudioPlayComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    //播放音频
    AppAudioPlayComponent.prototype.playAudio = function () {
        if (!this.playStatus) {
            this.audioObj.play();
        }
        else {
            this.audioObj.pause();
        }
    };
    /* 播放进度 */
    AppAudioPlayComponent.prototype.timeupdate = function () {
        if (this.touchEnable) {
            return false;
        }
        var currentaudio = this.audioObj;
        if (!currentaudio.duration) {
            return false;
        }
        var audioAllTime = currentaudio.duration;
        this.updateProcessUI(currentaudio.currentTime, audioAllTime);
    };
    AppAudioPlayComponent.prototype.updateProcessUI = function (currentTime, AllTimes) {
        this.audioProcess = currentTime * 100 / AllTimes;
        this.audioProcessTimes = this.getTimeformat(currentTime) + "/" + this.getTimeformat(AllTimes);
    };
    /* 进度直接移到当前播放位置 */
    AppAudioPlayComponent.prototype.moveCurrentTimes = function () {
        if (!this.audioObj.duration) {
            return false;
        }
        this.audioObj.currentTime = this.currentAudio.currentTime;
        this.updateProcessUI(this.audioObj.currentTime, this.audioObj.duration);
    };
    /* 播放事件 */
    AppAudioPlayComponent.prototype.play = function () {
        this.playStatus = true;
    };
    /* 暂停事件 */
    AppAudioPlayComponent.prototype.pause = function () {
        this.playStatus = false;
        this.showLoading = false;
    };
    /* 播放完毕 */
    AppAudioPlayComponent.prototype.ended = function () {
        this.showLoading = false;
        this.playStatus = false;
        this.currentAudio.currentTime = 0;
        //播放下一条
        this.playNext();
    };
    /* 正常播放 */
    AppAudioPlayComponent.prototype.canplaythrough = function () {
        this.showLoading = false;
    };
    /* 加载音频中... */
    AppAudioPlayComponent.prototype.warting = function () {
        this.showLoading = false;
    };
    /* 元数据加载完成 */
    AppAudioPlayComponent.prototype.loadeddata = function () {
        this.timeupdate();
        this.moveCurrentTimes();
        if (!this.firstPlay) {
            this.audioObj.play();
        }
    };
    /* 前进 */
    AppAudioPlayComponent.prototype.forward = function () {
        if (!this.playStatus) {
            return false;
        }
        if (this.audioObj.currentTime + 15 >= this.audioObj.duration) {
            this.audioObj.currentTime = this.audioObj.duration;
        }
        else {
            this.audioObj.currentTime = this.audioObj.currentTime + 15;
        }
    };
    /* 后退 */
    AppAudioPlayComponent.prototype.fallback = function () {
        if (!this.playStatus) {
            return false;
        }
        if (this.audioObj.currentTime - 15 < 0) {
            this.audioObj.currentTime = 0;
        }
        else {
            this.audioObj.currentTime = this.audioObj.currentTime - 15;
        }
    };
    /* 下一个 */
    AppAudioPlayComponent.prototype.playNext = function () {
        if (this.currentIndex < this.audioList.length - 1) {
            this.audioObj.pause();
            this.currentIndex++;
            this.currentAudio.currentTime = 0;
            this.currentAudio = this.audioList[this.currentIndex];
            this.audioObj.src = this.currentAudio.audioUrl;
            this.audioObj.play();
            this.saveUserAudioProcess(0, null);
        }
    };
    /* 上一个 */
    AppAudioPlayComponent.prototype.playPre = function () {
        if (this.currentIndex > 0) {
            this.audioObj.pause();
            this.currentIndex--;
            this.currentAudio.currentTime = 0;
            this.currentAudio = this.audioList[this.currentIndex];
            this.audioObj.src = this.currentAudio.audioUrl;
            this.audioObj.play();
            this.saveUserAudioProcess(0, null);
        }
    };
    AppAudioPlayComponent.prototype.getTimeformat = function (timeSeconds) {
        var theTime = timeSeconds; // 秒
        var theTime1 = 0; // 分
        var theTime2 = 0; // 小时
        if (theTime > 60) {
            theTime1 = Math.floor(theTime / 60);
            theTime = Math.floor(theTime % 60);
            if (theTime1 > 60) {
                theTime2 = Math.floor(theTime1 / 60);
                theTime1 = Math.floor(theTime1 % 60);
            }
        }
        var result = "" + Math.floor(theTime);
        if (theTime < 10) {
            result = "0" + result;
        }
        if (theTime1 > 0) {
            result = "" + Math.floor(theTime1) + ":" + result;
        }
        else {
            result = "0:" + result;
        }
        if (theTime2 > 0) {
            result = "" + Math.floor(theTime2) + ":" + result;
        }
        return result;
    };
    /* 获取播放列表 */
    AppAudioPlayComponent.prototype.getAudioListInfo = function () {
        return this.apiService.ajax({
            "type": "get",
            "url": 'sr/coursedna/queryCourseDNAList'
        });
    };
    /* 保存用户播进度 */
    AppAudioPlayComponent.prototype.saveUserAudioProcess = function (currentTime, callback) {
        this.apiService.ajax({
            "type": "post",
            "url": 'sr/coursedna/saveDNAUserAudioRecord/' + this.currentAudio.unitId + '/' + Math.floor(currentTime)
        }).subscribe(function () {
            if (callback) {
                callback();
            }
        });
    };
    /* 切换显示模式 */
    AppAudioPlayComponent.prototype.switchShowModel = function () {
        this.showTextModel = this.showTextModel == "day" ? "night" : "day";
    };
    AppAudioPlayComponent.prototype.onScroll = function ($event) {
        this.showToolBar = this.lastScrollTop < $event.srcElement.scrollTop;
        this.lastScrollTop = $event.srcElement.scrollTop;
    };
    /* 退出播放器 */
    AppAudioPlayComponent.prototype.exitAudio = function () {
        var _this = this;
        this.saveUserAudioProcess(this.audioObj.currentTime, function () {
            var link = ['survey', _this.learningPathOrLearningTourId, _this.surveyMetaId, _this.method];
            _this.router.navigate(link);
        });
    };
    AppAudioPlayComponent.prototype.closeDialog = function () {
        this.showTipEnable = false;
    };
    AppAudioPlayComponent.prototype.showDialog = function () {
        this.showTipEnable = true;
    };
    /*读取报告*/
    AppAudioPlayComponent.prototype.getReport = function () {
        var _this = this;
        this.apiService.getDNAReport("" + this.surveyId + "").subscribe(function (report) {
            _this.report = _this.resortReportItem(report.details);
        });
    };
    //兼容显示须序
    AppAudioPlayComponent.prototype.resortReportItem = function (reportItems) {
        var newReports = [];
        var nextSort = ["外向", "亲和", "开放", "严谨", "情绪稳定"];
        nextSort.forEach(function (item) {
            reportItems.forEach(function (subItem) {
                if (item == subItem.name) {
                    newReports.push(subItem);
                }
            });
        });
        return newReports;
    };
    AppAudioPlayComponent.prototype.touchstart = function ($event) {
        this.touchEnable = true;
        this.touchX = $event.touches[0].clientX;
        this.currentProcessWidth = $(this.el.nativeElement.querySelector(".audioPlay-play-wrap")).width();
        this.currentProcessBarWidth = $(this.el.nativeElement.querySelector(".audioPlay-play")).width();
    };
    AppAudioPlayComponent.prototype.touchstartContent = function ($event) {
        this.touchEnableContent = true;
        this.touchY = $event.touches[0].clientY;
    };
    AppAudioPlayComponent.prototype.touchmove = function ($event) {
        if (this.touchEnable) {
            var moveX = $event.touches[0].clientX - this.touchX;
            var currentaudio = this.audioObj;
            if (!currentaudio.duration) {
                return false;
            }
            var audioAllTime = currentaudio.duration;
            var moveValue = this.currentProcessBarWidth + moveX;
            if (moveValue >= 0 && moveValue <= this.currentProcessWidth) {
                this.moveTouchTimes = audioAllTime * ((this.currentProcessBarWidth + moveX) / this.currentProcessWidth);
                this.updateProcessUI(this.moveTouchTimes, audioAllTime);
            }
        }
        if (this.touchEnableContent) {
            var moveY = $event.touches[0].clientY - this.touchY;
            this.showToolBar = moveY <= 0;
        }
    };
    AppAudioPlayComponent.prototype.touchend = function () {
        this.touchEnable = false;
        this.touchEnableContent = false;
        if (this.moveTouchTimes != 0) {
            this.audioObj.currentTime = this.moveTouchTimes;
            this.moveTouchTimes = 0;
        }
    };
    return AppAudioPlayComponent;
}());
export { AppAudioPlayComponent };



// WEBPACK FOOTER //
// ./src/app/app-audio-play/app-audio-play.component.ts.pre-build-optimizer.js